import React, { useState, useEffect } from "react";
import AppContainer from "../../components/containers/AppContainer";
import { Divider, Stack, Typography, Box, MenuItem } from "@mui/material";
import DashboardChart from "./../../components/charts/DashboardChart";
import SelectInput from "../../components/select";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";

const RenderProfit = ({ icon: Icon, title, value }) => {
  return (
    <Stack direction={"row"} alignItems={"center"} gap={3}>
      <Box
        sx={{
          width: 55,
          height: 55,
          borderRadius: "50%",
          bgcolor: "primary.light",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon sx={{ color: "primary.bgLight", fontSize: 30 }} />
      </Box>
      <Typography variant="body1" fontWeight={600}>
        {title}
      </Typography>
      <Typography fontSize={"1.125rem"} fontWeight={600} ml={3}>
        CA$ {value}
      </Typography>
    </Stack>
  );
};

const PlatformChart = ({ earnings = [] }) => {
  const [filter, setFilter] = useState("yearly");

  // Calculate total earnings
  const totalEarnings = earnings.reduce(
    (sum, item) => sum + item.totalEarnings,
    0
  );

  return (
    <AppContainer>
      <Stack
        px={2.5}
        py={3}
        direction={{ md: "row" }}
        alignItems={{ md: "center" }}
        justifyContent={"space-between"}
        gap={2}
      >
        <Stack>
          <Typography variant="h5" fontWeight={600}>
            Platform Earning Chart
          </Typography>
          <Typography fontSize={"1.125rem"} color={"customColor.dustyGray"}>
            Yearly Earning Overview
          </Typography>
        </Stack>
        <Stack
          direction={{ sm: "row" }}
          alignItems={{ md: "center" }}
          gap={{ xs: 2, md: 4 }}
        >
          <RenderProfit
            icon={MonetizationOnOutlinedIcon}
            title={"Total Earnings"}
            value={totalEarnings}
          />
        </Stack>
      </Stack>
      <Divider sx={{ mb: 2, borderColor: "#BDBDBD" }} />
      <Stack px={2.5} pb={2}>
        <Stack direction={{ sm: "row" }} justifyContent={"space-between"}>
          <Typography variant="h5" fontWeight={600}>
            Revenue
          </Typography>
          <SelectInput
            formStyleProps={{ width: { xs: "100%", sm: 150 } }}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <MenuItem value={"yearly"}>Yearly </MenuItem>
            <MenuItem value={"monthly"}>Month </MenuItem>
          </SelectInput>
        </Stack>
        <Box mt={3} height={{ xs: "auto", md: "auto" }}>
          <DashboardChart earnings={earnings} />
        </Box>
      </Stack>
    </AppContainer>
  );
};

export default PlatformChart;
